type NavItem = {
  name: string,
  url: string,
  version?: string,
  class?: string,
  subDir?: string[],
  children?: NavItem[]
}

type NavType = {
  items: (NavItem & {
    children?: NavItem[]
  })[]
};

const exportedObject: NavType = {
  items: [
    {
      name: "Application",
      url: "/Application",
      class: "first-level-dropdown-toggle",
      children: [
        {
          name: 'Conversations',
          url: '/conversations',
          subDir: ['/conversations'],
          class: "sidebar-child-nav-item-custom"
        },
        {
          name: 'Live',
          url: '/live',
          subDir: ['/live'],
          class: "sidebar-child-nav-item-custom"
        },
        {
          name: 'Trends',
          url: '/trends',
          subDir: [],
          class: "sidebar-child-nav-item-custom"
        },
        {
          name: 'CallPaths',
          url: '/callpaths',
          subDir: ['/sankey/report'],
          children: [
            {
              name: 'Flow',
              url: '/flow',
              subDir: ['/sankey/report']
            },
            {
              name: 'End States',
              url: '/end-states',
              subDir: ['/sankey/report']
            }
          ]
        },
        {
          name: 'Identity Provider',
          url: '/identity_provider',
          subDir: ['/identity_provider'],
          class: 'sidebar-child-nav-item-custom'
        },
        {
          name: 'User Profiles',
          url: '/user_activity',
          subDir: ['/user_activity'],
          class: 'sidebar-child-nav-item-custom'
        },
        {
          name: 'Intents & Entities',
          url: '/intents&entities',
          subDir: [
            '/intents&entities',
            '/intents&entities/intentdetails',
            '/intents&entities/entitydetails',
            '/intents&entities/addintent',
            '/intents&entities/import'
          ],
          class: 'sidebar-child-nav-item-custom'
        },
        {
          name: 'Prompts',
          url: '/prompts',
          subDir: ['/prompts', '/promptsImport', '/groups'],
          class: 'sidebar-child-nav-item-custom'
        },

        {
          name: 'Reporting',
          url: '/reporting',
          subDir: ['/reporting'],
          class: 'sidebar-child-nav-item-custom'
        },
        // {
        //   name: 'Monitoring',
        //   url: '/monitoring',
        //   subDir: ['/monitoring'],
        //   class: 'sidebar-nav-item'
        // },
      ]
    },
    {
      name: 'Messages Lite',
      version: 'lite',
      url: '/conversationsLite',
      subDir: ['/conversationsLite'],
      class: 'sidebar-nav-item-custom'
    },
    {
      name: 'Test Harness',
      url: '/test_harness',
      subDir: [],
      class: 'sidebar-nav-item-custom'
    },
    {
      name: 'Callback',
      url: '/Callback',
      class: 'first-level-dropdown-toggle',
      children: [
        {
          name: 'Home',
          url: '/callback-service',
          subDir: ['/callback-service'],
          class: 'sidebar-child-nav-item-custom'
        },
        {
          name: 'Advanced Metrics',
          url: '/callback-metrics',
          subDir: ['/callback-metrics'],
          class: 'sidebar-child-nav-item-custom'
        },
        {
          name: 'Scheduled Callback',
          url: '/scheduled-callback',
          subDir: ['/scheduled-callback'],
          class: 'sidebar-child-nav-item-custom'
        },
        {
          name: 'Settings',
          url: '/callback-settings',
          subDir: ['/callback-settings'],
          class: 'sidebar-child-nav-item-custom'
        }
      ]
    },
    {
      name: 'Survey',
      url: '/survey',
      subDir: [],
      class: 'sidebar-nav-item-custom'
    },
    {
      name: 'Hours of Operation',
      url: '/HOO',
      class: "first-level-dropdown-toggle",
      children: [
        {
          name: 'Home',
          url: '/hours_of_operation',
          subDir: ['/hours_of_operation'],
          class: 'sidebar-child-nav-item-custom'
        },
        {
          name: 'Shared Exceptions',
          url: '/hoo_shared_exception_days',
          subDir: ['/hoo_shared_exception_days'],
          class: 'sidebar-child-nav-item-custom'
        },
        {
          name: 'Logs',
          url: '/hoo_logs',
          subDir: ['/hoo_logs'],
          class: 'sidebar-child-nav-item-custom'
        }
      ]
    },
    {
      name: 'Versay Survey',
      url: '/vss/designer',
      subDir: [],
      class: 'sidebar-nav-item-custom'
    },
    {
      name: 'Config Manager',
      url: '/CM',
      class: "first-level-dropdown-toggle",
      children: [
        {
          name: 'Home',
          url: '/configuration-manager-home',
          subDir: [],
          class: 'sidebar-child-nav-item-custom'
        },
        {
          name: 'Logs',
          url: '/configuration-manager-logs',
          subDir: [],
          class: 'sidebar-child-nav-item-custom'
        }
      ]
    },
    {
      name: 'Logs',
      url: '/logs',
      subDir: [],
      class: 'sidebar-nav-item-custom'
    },
    {
      name: 'Archived Logs',
      url: '/archived-logs',
      subDir: [],
      class: 'sidebar-nav-item-custom'
    },
    {
      name: "Admin",
      url: '/Admin',
      class: "first-level-dropdown-toggle",
      children: [
        {
          name: 'Accounts',
          url: '/admin',
          subDir: ['/admin'],
          class: 'sidebar-child-nav-item-custom'
        },
        {
          name: 'UI Settings',
          url: '/ui_settings',
          subDir: ['/application_settings'],
          class: 'sidebar-child-nav-item-custom'
        }
      ]
    },

    // {
    //   name: 'User Satisfaction',
    //   url: '/user_satisfaction',
    //   icon: 'icon-people'
    // }
  ],
};

export default exportedObject;
